import { Funcoes } from '../../../utils/FuncoesUtils'
import { UserData } from './styles'
import { useState } from 'react'
import Button from '@material-ui/core/Button'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined'
import { useAuth } from 'react-oidc-context'

export default function UserDataComponent() {
    const auth = useAuth()
    let dadosUsuario = {
        nome: '',
        email: ''
    };

    if (auth.isAuthenticated) {
        dadosUsuario.nome = auth.user.profile.name;
        dadosUsuario.email = auth.user.profile.email;
    }

    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => setAnchorEl(event.currentTarget)

    const handleClose = () => setAnchorEl(null)

    const logout = () => {
        auth.removeUser()
        auth.signoutRedirect({
            post_logout_redirect_uri: process.env.REACT_APP_URL_TCECOMUNICA
        })
    }

    return (
        <UserData id="UserData_UserData">
            <Button id="btn-userdata" aria-controls="userdata-menu" aria-haspopup="true" onClick={handleClick}>
                <UserData.Icon id="UserData_Icon"><PermIdentityOutlinedIcon /></UserData.Icon>
                <UserData.Name id="UserData_Name">{Funcoes.Capitalize(dadosUsuario.nome)}</UserData.Name>
                <UserData.CaretIcon id="UserData_CaretIcon"><ExpandMoreIcon /></UserData.CaretIcon>
            </Button>
            <Menu
                id="userdata-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose} className="userdata-top-box">
                    <UserData.Container id="UserData_Container">
                        <UserData.LetterName id="UserData_LetterName">{Funcoes.GetFirstLetter(dadosUsuario.nome)}</UserData.LetterName>
                        <UserData.ContentInfo id="UserData_ContentInfo">
                            <UserData.NameUser id="UserData_NameUser">{Funcoes.Capitalize(dadosUsuario.nome)}</UserData.NameUser>
                            <UserData.Email id="UserData_Email">{dadosUsuario.email}</UserData.Email>
                        </UserData.ContentInfo>
                    </UserData.Container>
                </MenuItem>
                <MenuItem onClick={() => logout()} className="userdata-exit-app"><ExitToAppIcon /> Sair</MenuItem>
            </Menu>
        </UserData>
    )
}